import { render, staticRenderFns } from "./BnDokDialog.vue?vue&type=template&id=02d624a2&"
import script from "./BnDokDialog.vue?vue&type=script&lang=js&"
export * from "./BnDokDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports